import React from 'react'
import PropTypes from 'prop-types'
import { BaseForm as Form } from 'component/base'

export const Dealer = props => {
  return (
    <Form.Dropdown.WithAPI
      url='/api/staff/master/dealer'
      keyName='id'
      valueName='id'
      textName='name'
      {...props}
    />
  )
}

Dealer.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
}

Dealer.defaultProps = {
  name: 'dealer_kbn',
  label: 'ディーラー',
  value: undefined,
}
